import { FC } from "react";
import "./Button.css";

interface ButtonProps {
  title: string;
  onClick?: () => void;
  hover?: string | null;
  cardIndex?: number;
  buttonHoverIndex?: number | null;
  disabled: string;
}

const Button: FC<ButtonProps> = ({
  title,
  hover,
  cardIndex,
  buttonHoverIndex,
  onClick,
  disabled,
}) => {
  const hasHoverEffect = hover && cardIndex === buttonHoverIndex;

  const displayButton = (disable: string):string => {

    if(disable === "enable"){
      return 'button-enable'
    } else{
      return 'button-disable'
    }
  };

  return (
    <div className={hasHoverEffect ? hover : displayButton(disabled)} onClick={onClick}>
      {title}
    </div>
  );
};

export default Button;
